module.exports = __webpack_public_path__ + "static/media/B (5).818aa94a.jpg";